// ============================================================================
// Products menu — force <details> open at xl+, leave it collapsible below
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $els = $('[data-open-on-desktop]');
        if (!$els.length) return;

        const mql = window.matchMedia('(min-width: 1280px)');

        function sync() {
            $els.each(function () {
                if (mql.matches) this.setAttribute('open', '');
                else this.removeAttribute('open');
            });
        }

        sync();

        if (mql.addEventListener) mql.addEventListener('change', sync);
        else if (mql.addListener) mql.addListener(sync);
    });
})(jQuery);
